import { useCallback, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import TextInput from '@alltrails/denali/components/TextInput';
import Modal from '@alltrails/modal/components/Modal/Modal';
import { useAppDispatch, useAppSelector } from '../../redux';
import { updateAdminStyleSettings } from '../../redux/reducer';
import { StyleId } from '../../types/Styles';

type Props = {
  isOpen: boolean;
  adminStyleSourceUrlId: StyleId;
  onClose: () => void;
};

const CustomURLModal = ({ isOpen, adminStyleSourceUrlId, onClose }: Props) => {
  const dispatch = useAppDispatch();
  const { adminStyleSettings } = useAppSelector(state => ({
    adminStyleSettings: state.map.adminStyleSettings
  }));
  const [url, setUrl] = useState(adminStyleSettings?.styleSourceUrls?.[adminStyleSourceUrlId!]);
  const isDisabled = useMemo(
    () => !url || url === adminStyleSettings?.styleSourceUrls?.[adminStyleSourceUrlId!],
    [adminStyleSettings?.styleSourceUrls, adminStyleSourceUrlId, url]
  );

  const handleSubmit = useCallback(() => {
    dispatch(
      updateAdminStyleSettings({
        ...adminStyleSettings,
        styleSourceUrls: { ...adminStyleSettings?.styleSourceUrls, [adminStyleSourceUrlId!]: url }
      })
    );
    onClose();
  }, [adminStyleSettings, adminStyleSourceUrlId, dispatch, onClose, url]);

  return (
    <Modal
      isOpen={isOpen}
      onCloseRequest={onClose}
      title={<FormattedMessage defaultMessage="Custom map source" />}
      size="lg"
      buttons={{
        primaryButton: {
          onClick: handleSubmit,
          text: <FormattedMessage defaultMessage="Apply" />,
          disabled: isDisabled
        }
      }}
    >
      <TextInput
        helperText="URL must be for a WMS raster tile source, containing {'{x}, {y} and {z}'} placeholders"
        labelText={`Source URL (${adminStyleSourceUrlId})`}
        onChange={setUrl}
        value={url}
      />
    </Modal>
  );
};

export default CustomURLModal;
